import { createAsyncThunk } from "@reduxjs/toolkit";
import { get, post } from "../../api/api";
import { setLoading } from "../../app/loadingSlice";

//Call fetch users api request
export const fetchReportsList = createAsyncThunk(
    "report/list",
    async (finalObj: object, { dispatch }) => {
        dispatch(setLoading(true));
        try {
            const response = await post(`/report/list`, finalObj);
            return response.data;
        } catch (error) {
            console.log(error);
        } finally {
            dispatch(setLoading(false));
        }
    }
);

